import { Pipe } from '@angular/core';
var IsNullPipe = (function () {
    function IsNullPipe() {
    }
    IsNullPipe.prototype.transform = function (input) {
        return input === null;
    };
    IsNullPipe.decorators = [
        { type: Pipe, args: [{ name: 'isNull' },] },
    ];
    /** @nocollapse */
    IsNullPipe.ctorParameters = function () { return []; };
    return IsNullPipe;
}());
export { IsNullPipe };
//# sourceMappingURL=is-null.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-null.js
// module id = 251
// module chunks = 4